import { css } from '@emotion/react';
// Constants
import { Color } from "../../constants/Colors";

export const useStyles = (props) => ({
    userRoleContainer: css({
        position: 'relative',
        boxSizing: 'border-box',
        padding: '24px',
        width: '100%',
        height: '260px',
        backgroundColor: Color.primary[400],
        color: Color.neutral[0],
    }),
    userRoleBox: css({
        textAlign: 'center',
        marginTop: '15px',
    }),
});
